export const ENUM_VIEW_MODE = {
  RXP_VIEW: 'RxP View',
  CUSTOMER_VIEW: 'Customer View',
  MANUFACTURER_VIEW: 'MFR View'
} as const;
